module.exports = __webpack_public_path__ + "img/ysxk.f22e084a.jpg";